// extracted by mini-css-extract-plugin
export default {"container":"_1ZRo1","disabled":"_35LPM","avatar":"_3qdoQ","fakeInput":"_2mjNK","placeholder":"_2c0Hl"};